import React from 'react';
import {ScrollView, StyleSheet, TextInput, TouchableOpacity, View} from 'react-native';
import Header from '../components/HomeHeader';
import {Text, withTheme} from "react-native-paper";
import {useMst} from "../models/RootModel";
import {observer} from "mobx-react-lite";
import {useMediaQuery} from "react-responsive";
import Footer from "../components/Footer";
import Copyright from "../components/Copyright";
import Login from "../components/Login";
import i18n from "../translations/Translations";

export interface ForgotPasswordPageProps {
    theme: ReactNativePaper.Theme
}

const ForgotPasswordPage = observer((props: ForgotPasswordPageProps) => {
    const state = useMst();
    const desktopVersion = useMediaQuery({minWidth: props.theme.desktopBreakpoint})

    const [email, setEmail] = React.useState(state.customer.email.toString());
    const [message, setMessage] = React.useState("");

    const styles = StyleSheet.create({
        container: {
            backgroundColor: "white"

        },
        modal: {
            elevation: 0
        },
        product_page: {
            paddingHorizontal: 160, flexDirection: "row", justifyContent: "center", zIndex: -1
        },
        title: {
            fontFamily: props.theme.fontList.primaryFontBold,
            fontSize: 20,
            letterSpacing: 4,
            marginBottom: 16
        },
        input_label: {
            fontFamily: props.theme.fontList.primaryFontDefault,
            fontSize: 15,
            color: "#aaaaaa",
            letterSpacing: 2,
            marginBottom: 10,
            marginTop: 20
        },
        input: {
            alignSelf: "center",
            height: 36,
            width: "100%",
            outlineColor: "#00000000",
            backgroundColor: "#eeeeee",
            paddingLeft: 16,
            paddingRight: 16,
            fontFamily: props.theme.fontList.primaryFontDefault,
            letterSpacing: 2
        },
        logo: {
            width: 450,
            height: 200,
            marginBottom: 40,
            resizeMode: "contain",
            alignSelf: "center"
        },
        button: {
            marginHorizontal: 10,
            backgroundColor: props.theme.colors.button_color,
            width: "100%",
            height: 36
        },
        button_text: {
            color: "white",
            alignSelf: "center",
            marginVertical: "auto",
            fontFamily: props.theme.fontList.primaryFontBold,
            letterSpacing: 3
        },
        bottom_text_wrapper: {
            flexDirection: "row",
            marginTop: 30,
            width: "100%",
            justifyContent: "space-between"
        },
        login_error:{
            marginTop: 28,
            marginBottom: 10,
            fontSize: 14,
            alignSelf: "center",
            flexWrap: "wrap"
        },
        description:{
            fontFamily: props.theme.fontList.primaryFontDefault,
            fontSize: 14,
            marginTop: 18,
            marginBottom: 4
        },
        content: {
            width: 420,
            elevation: 4,
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: "center",
            zIndex: -1
        }
    });


    function resetPassword(){
        // TODO actual handling of password reset
        setMessage(i18n.t("forgot_password.message"));
        setEmail("");
    }

    return (
            <View style={styles.container}>
                <ScrollView style={{height: "100vh", paddingBottom: 32}}>
                    <Header/>
                    <View style={styles.content}>
                        <Text style={styles.title}>{i18n.t("forgot_password.title")}</Text>
                        <Text style={styles.description}>{i18n.t("forgot_password.description")}</Text>
                        <Text style={styles.input_label}>{i18n.t("forgot_password.email")}</Text>
                        <TextInput style={styles.input}
                                   value={email}
                                   textContentType={"emailAddress"}
                                   onChangeText={text => {
                                       setMessage("");
                                       setEmail(text);
                                   }}
                        />
                        <Text style={styles.login_error}>{message}</Text>
                        <TouchableOpacity activeOpacity={props.theme.defaultTouchableOpacity} style={styles.button} onPress={resetPassword}>
                            <Text style={styles.button_text}>{i18n.t("forgot_password.btn")}</Text>
                        </TouchableOpacity>
                    </View>
                    <View style={{zIndex: -1}}>
                        <Footer verticalMargin={50}/>
                        <Copyright/>
                    </View>
                </ScrollView>
            </View>
    );
})

export default withTheme(ForgotPasswordPage);